<template>
  <cargo-advance-select
    :disabled="disabled"
    :select-type="TYPE_NAMES.static_data_Department"
    :cache="false"
    filterable
    :default-value="departmentId||''"
    :static-options="options"
    :placeholder="placeholder"
    filter-type="global"
    @parentCallBack="p=>{$emit('change',p)}"
  />
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { sleep, SyncManager } from '@/utils/commonUtil'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

export default {
  name: 'CargoDepartmentSelect',
  components: { cargoAdvanceSelect },
  props: {
    disabled: { type: Boolean, default: false },
    officeId: { type: Number, default: 0 },
    departmentId: { type: Number, default: 0 },
    enables: { type: Boolean, default: false },
    placeholder: { type: String, default: '' }
  },
  data() {
    return {
      TYPE_NAMES,
      originOptions: [],
      extraOption: null
    }
  },
  computed: {
    options() {
      let data = this.originOptions
      if (this.extraOption) {
        const index = this.originOptions.findIndex(p => p.uuid === this.extraOption.uuid)
        if (index < 0) {
          data = [this.extraOption, ...this.originOptions]
        }
      }
      if (this.enables) {
        return data.filter(p => p.active || p.departmentId === this.departmentId)
      }
      return data
    }
  },
  watch: {
    officeId: {
      immediate: true,
      async handler(newVal, oldVal) {
        // 第一次进入，暂停一下，在created之后执行
        if (typeof oldVal === 'undefined') {
          await sleep(0)
        }
        this.syncManager.execute(async() => {
          this.originOptions = []
          if (this.officeId > 0) {
            this.init()
            const office = this.officeList.find(p => Number(p.officeId) === this.officeId)
            if (office) {
              this.originOptions = this.allDepartments.filter(p => p.officeUuid === office.uuid)
            }
          }
          this.handleDefaultValue()
        })
      }
    },
    departmentId(newVal) {
      if (newVal && this.allDepartments) {
        this.handleDefaultValue()
      }
    }
  },
  created() {
    this.TYPE_NAMES = TYPE_NAMES
    this.officeList = null
    this.allDepartments = null
    this.syncManager = new SyncManager()
  },
  methods: {
    init() {
      if (this.officeId > 0 && !this.officeList) {
        this.officeList = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
      }
      if (!this.allDepartments) {
        this.allDepartments = getCacheListByKey(basicCacheKeys.basic_data_Department_All)
      }
    },
    handleDefaultValue() {
      this.extraOption = null
      if (!this.departmentId) {
        return
      }
      for (const item of this.originOptions) {
        if (item.departmentId === this.departmentId) {
          return
        }
      }
      const department = this.allDepartments.find(p => p.departmentId === this.departmentId)
      this.extraOption = department || null
    }
  }
}
</script>

<style>
</style>
